<template>
  <ul class="sidebar-menu">
    <li class="header">TOOLS</li>
    <router-link tag="li" class="pageLink" to="/">
      <a>
        <i class="fa fa-home"></i>
        <span class="page">Pagina Inicial</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/calendario" v-if="possuiAgendamento">
      <a>
        <i class="fa fa-calendar"></i>
        <span class="page">Calendário</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/pedidos" v-if="possuiDelivery">
      <a>
        <i class="fa fa-pencil-square-o"></i>
        <span class="page">Pedidos</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/clientes">
      <a>
        <i class="fa fa-users"></i>
        <span class="page">Clientes</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/produtos" v-if="possuiDelivery">
      <a>
        <i class="fa fa-cubes" style="width=2%"></i>
        <span class="page">Produtos</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/servicos" v-if="possuiAgendamento">
      <a>
        <i class="fa fa-wrench"></i>
        <span class="page">Servicos</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/categorias" v-if="possuiDelivery">
      <a>
        <i class="fa fa-tags"></i>
        <span class="page">Categorias de Produtos</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/categorias-servicos" v-if="possuiAgendamento">
      <a>
        <i class="fa fa-tags"></i>
        <span class="page">Categorias de Serviços</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/campanhas" v-if="possuiDelivery">
      <a>
        <i class="fa fa-facebook"></i>
        <span class="page">Campanhas</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/colaborador" v-if="possuiAgendamento">
      <a>
        <i class="fa fa-id-card-o" aria-hidden="true"></i>
        <span class="page">Colaborador</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/problemas" v-if="possuiAssistencia">
      <a>
        <i class="fa fa-lightbulb-o"></i>
        <span class="page">Problemas/Solução</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/solicitacoes" v-if="possuiTurismo">
      <a>
        <i class="fa fa-list-ul"></i>
        <span class="page">Solicitações</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/pacotes" v-if="possuiTurismo">
      <a>
        <i class="fa fa-suitcase"></i>
        <span class="page">Pacotes de Viagem</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/perguntas" v-if="possuiTurismo">
      <a>
        <i class="fa fa-pencil-square-o"></i>
        <span class="page">Perguntas Personalizadas</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/filtros" v-if="possuiTurismo">
      <a>
        <i class="fa fa-filter"></i>
        <span class="page">Filtros</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/inclusao-rapida-produtos" v-if="isAdmin">
      <a>
        <i class="fa fa-pencil-square-o"></i>
        <span class="page">Produtos (inclusão rápida)</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/inclusao-rapida-categorias" v-if="isAdmin">
      <a>
        <i class="fa fa-pencil-square-o"></i>
        <span class="page">Categorias (inclusão rápida)</span>
      </a>
    </router-link>

    <!-- <router-link tag="li" class="pageLink" to="/condpagto">
      <a>
        <i class="fa fa-credit-card "></i>
        <span class="page">Condição de Pagamento</span>
      </a>
    </router-link> -->
    <!--<router-link tag="li" class="pageLink" to="/tables">
      <a>
        <i class="fa fa-table"></i>
        <span class="page">Tables</span>
      </a>
    </router-link>-->

    <li class="header">SETTINGS</li>
    <!-- <router-link tag="li" class="pageLink" to="/tasks">
      <a>
        <i class="fa fa-tasks"></i>
        <span class="page">Tasks</span>
      </a>
    </router-link> -->
    <router-link tag="li" class="pageLink" to="/setting" v-if="possuiDelivery">
      <a>
        <i class="fa fa-cog"></i>
        <span class="page">Configurações</span>
      </a>
    </router-link>

    <router-link tag="li" class="pageLink" to="/help">
      <a>
        <i class="fa fa-question-circle"></i>
        <span class="page">Ajuda</span>
      </a>
    </router-link>

    <li class="header">EMPRESAS</li>
    <li tag="li" class="pageLink" v-for="(empresa, index) in options">    
      <a @click="changeEmpresa(index, empresa.fb_id)" :class="[index === empresa_ativa ? 'empresaLink' : '']">
        <i class="fa fa-building-o iconEmpresa"></i>
        <span class="page">{{empresa.nome}}</span>
      </a>
    </li>

    <!-- <li class="treeview">
      <a href="#">
        <i class="fa fa-folder-o"></i>
        <span>Files</span>
        <span class="pull-right-container">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <li>
          <a href="#">
            <i class="fa fa-file-word-o"></i> Item 1
          </a>
        </li>
        <li>
          <a href="#">
            <i class="fa fa-file-picture-o"></i> Item 2
          </a>
        </li>
        <li>
          <a href="#">
            <i class="fa fa-file-pdf-o"></i> Item 3
          </a>
        </li>
      </ul>
    </li>

    <li class="header">LOGS</li>
    <router-link tag="li" class="pageLink" to="/access">
      <a>
        <i class="fa fa-book"></i>
        <span class="page">Access</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/server">
      <a>
        <i class="fa fa-hdd-o"></i>
        <span class="page">Server</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/repos">
      <a>
        <i class="fa fa-heart"></i>
        <span class="page">Repos</span>
        <small class="label pull-right bg-green">AJAX</small>
      </a>
    </router-link> 

    <li class="header">PAGES</li>
    <router-link tag="li" class="pageLink" to="/logout">
      <a>
        <i class="fa fa-circle-o text-yellow"></i>
        <span class="page"> Logout</span>
      </a>
    </router-link> -->
    <!-- <router-link tag="li" class="pageLink" to="/404">
      <a>
        <i class="fa fa-circle-o text-red"></i>
        <span class="page"> 404</span>
      </a>
    </router-link> -->
  </ul>
</template>
<script>
export default {
  name: 'SidebarName',
  data: function () {
    return {
      options: this.$store.state.empresas,
      empresa_ativa: this.$store.state.empresa_ativa,
      possuiAgendamento: false,
      possuiDelivery: false,
      possuiAssistencia: false,
      possuiTurismo: false,
      isAdmin: false
    }
  },
  created () {
    this.verificaMenu();
    this.isAdmin = localStorage.getItem('usuario') === 'contato@sevsolucoes.com';
  },
  methods: {
    changeEmpresa(index, fb_id) {
      localStorage.setItem('INDEXEMPRESA', index)
      localStorage.setItem('FB_ID', fb_id)
      this.$router.go()
    },
    verificaMenu() {
      let modulos = (localStorage.getItem('modulos')).split(',');
      console.log('modulos => ', modulos)
      modulos.forEach(element => {
        switch (element) {
          case 'delivery':
            this.possuiDelivery = true            
            break;
          case 'assistencia':
            this.possuiAgendamento = true
            this.possuiAssistencia = true
            break;
          case 'agencia_turismo':
            this.possuiTurismo = true
            break;
          default:
            break;
        }
      });
    }
  }
}
</script>
<style>
  /* override default */
  .sidebar-menu>li>a {
    padding: 12px 15px 12px 15px;
  }

  .sidebar-menu li.active>a>.fa-angle-left, .sidebar-menu li.active>a>.pull-right-container>.fa-angle-left {
    animation-name: rotate;
    animation-duration: .2s;
    animation-fill-mode: forwards;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(-90deg);
    }
  }

  .iconEmpresa {
    color: #F29C12
  }

  .empresaLink{
    border-left: 3px solid!important;
    border-color: #3c8dbc!important;
  }
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?21c5c44c